import { Box, Size, Vector } from '../../models';

export function newBox(position: Vector, size: Size, rotation = 0, lockAspectRatio?: boolean): Box {
  return {
    position,
    size,
    rotation,
    lockAspectRatio,
    type: 'BOX',
  };
}
